/* eslint-disable filenames/match-exported */
import React from 'react';

import cn from '@src/util/cnHelper';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({className, type, ...props}, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-9 w-full rounded-md border-[1.5px] border-peppercorn-200 bg-transparent px-3 py-1 text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-peppercorn-800 placeholder:text-peppercorn-500 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-peppercorn-800 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export default Input;
